import type React from "react";

const RecommendedFor: React.FC = () => {
	const recommendations = [
		{
			id: "new-skill",
			text: "新しいスキルを身につけたい",
			icon: "🎯",
		},
		{
			id: "motivation",
			text: "自己学習のモチベーションを高めたい",
			icon: "💪",
		},
		{
			id: "friend",
			text: "一緒に学べる仲間がほしい",
			icon: "🤝",
		},
		{
			id: "knowledge",
			text: "他の人と知識やアイデアを交換したい",
			icon: "💡",
		},
		{
			id: "generation",
			text: "様々な世代と交流してみたい",
			icon: "👥",
		},
		{
			id: "growth",
			text: "今の自分をもっと成長させたい",
			icon: "🌱",
		},
	];

	return (
		<section className="py-16 md:py-24 bg-white">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="text-center mb-12">
					<h2 className="text-3xl md:text-4xl font-bold mb-4">
						こんな方におすすめ
					</h2>
					<p className="text-lg text-gray-600">
						学習ギルドは以下のような方に最適です
					</p>
				</div>

				<div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto">
					{recommendations.map((item) => (
						<div
							key={item.id}
							className="flex items-center space-x-4 p-4 bg-gray-50 rounded-lg"
						>
							<div className="text-2xl">{item.icon}</div>
							<p className="text-lg">{item.text}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default RecommendedFor;
